import * as React from 'react';
import { Route, Routes } from 'react-router-dom';
import { CheckTask } from './CheckTask';
import { InitiateWorkflow } from './InitiateWorkflow';
import { Four04 } from 'gossamer-front-end';
import { WorkflowCreate } from './WorkflowCreate';
import { WorkflowDisplay } from './WorkflowDisplay';
import { ManageWorkflow } from './ManageWorkflow';

export const WorkflowRoutes = (): React.JSX.Element => (
  <Routes>
    <Route path="/check-task/:key" element={<CheckTask />} />
    <Route path="/create" element={<WorkflowCreate />} />
    <Route path="/display/:key" element={<WorkflowDisplay />} />
    <Route path="/initiate" element={<InitiateWorkflow />} />
    <Route path="/manage" element={<ManageWorkflow />} />
    <Route path="*" element={<Four04 />} />
  </Routes>
);
